import { ProductDetailsDtoResponse } from '../core/models/product-details.dto-response';
import { ProductCardDtoResponse } from 'app/core/models/product-card-dto-response';

export class ProductDetailsBaseComponent {
  protected addSkuToDetails(product: any/*ProductDetailsDtoResponse, ProductCardDtoResponse*/): void {
    //if (product !== null) {
      if (Array.isArray(product.details)) {
        // djb:move to the top of the list (note: LIFO)
        //product.details.push({
        product.details.unshift({
          label: 'FC.ProductDetail.Label.PartNumber',
          value: product.longSKU,
          listViewOnly: false
        });
        //product.details.push({
        product.details.unshift({
          label: 'FC.ProductDetail.Label.SKUNumber',
          value: product.shortSKU,
          listViewOnly: false
        });
        // djb:28.i.i-remove empty details
        product.details = product.details.filter(d => (d.value !== ""));
      }
    //}
  }
}
